module.exports = __webpack_public_path__ + "static/tineo-05b2b5d518ecf87d108242b9858269c6.png";